module.exports = __webpack_public_path__ + "img/borrow_overdue.ad37e2a1.png";